export default "__VITE_ASSET__0MR4kydH__"